<div class="settings">
    <div class="settings-header">
        <a class="settings-header-back back-button" (click)="goBack()">
            <i class="fa-solid fa-chevron-left"></i>
            <div class="back text">{{ 'WebApp.v1.Shared.Buttons.Back' | translate }}</div>
        </a>

        <div class="settings-header-logo" (click)="goToMenu()">
            <img
                [src]="companyLogo()"
                (error)="getHowdyLogo()"
                [class.not-howdy]="!isHowdyLogo"
                class="logo"
                alt="logo"
            >
                <p class="text">{{ 'WebApp.v1.Shared.AwarenessByHowdy' | translate }}</p>
        </div>
    </div>

    <div class="settings-content">
        <div class="settings-content-action">
            <app-pill
                class="pill-mini"
                [class.expanded]="pillExpanded"
            >
                <app-feature-pill-menu
                    #pillMenu
                    class="pill-menu"
                    [pillMini]="true"
                    (expandedChange)="pillExpanded = $event"
                ></app-feature-pill-menu>
            </app-pill>
        </div>

        <div class="settings-content-header">
            <div class="settings-content-header-title">{{ 'WebApp.v1.Settings.Title' | translate }}</div>
            <div class="settings-content-header-name">{{ fullname }}</div>
        </div>

        <div class="settings-content-container">
            <form [formGroup]="form" class="settings-content-container-form">
                <div class="settings-content-container-form-row"> 
                    <app-checkbox formControlName="notifyBySMS">
                        <div class="settings-content-container-form-row-checkbox">{{ 'WebApp.v1.Settings.SmsNotification' | translate }}
                            @if (nextSMSNotificationDate) {
                                <span>{{ 'WebApp.v1.Shared.Buttons.Next' | translate }} {{ nextSMSNotificationDate | date:'dd/MM/YYYY' }}</span>
                            }
                        </div>
                    </app-checkbox>
                </div>

                <div class="settings-content-container-form-row">
                    <app-checkbox formControlName="notifyByEmail">
                        <div class="settings-content-container-form-row-checkbox">{{ 'WebApp.v1.Settings.EmailNotification' | translate }}
                            @if (nextEmailNotificationDate) {
                                <span>{{ 'WebApp.v1.Shared.Buttons.Next' | translate }} {{ nextEmailNotificationDate | date:'dd/MM/YYYY' }}</span>
                            }
                        </div>
                    </app-checkbox>
                </div>

                <div class="settings-content-container-form-row">
                    <app-checkbox formControlName="notifyByPush">
                        <div class="settings-content-container-form-row-checkbox">{{ 'WebApp.v1.Settings.PushNotification' | translate }}
                            @if (nextPushNotificationDate) {
                                <span>{{ 'WebApp.v1.Shared.Buttons.Next' | translate }} {{ nextPushNotificationDate | date:'dd/MM/YYYY' }}</span>
                            }
                        </div>
                    </app-checkbox>
                </div>

                <div class="settings-content-container-form-row">
                    <app-select
                        formControlName="userLanguage"
                        [title]="'WebApp.v1.Settings.Language' | translate"
                        [options]="languages"
                        [isLoading]="languageLoading"
                    ></app-select>
                </div>
            </form>

            <div class="settings-content-container-schema">
                <div class="settings-content-container-schema-title">
                    {{ 'WebApp.v1.Settings.Theme' | translate }}
                    <span>{{ 'WebApp.v1.Settings.ComingSoon' | translate }}</span>
                </div>
                <img src="assets/img/color-schema.png" alt="color schema image">
            </div>
        </div>
    </div>
</div>